import React, {  useEffect } from 'react';
import { Table, Input, Select } from 'antd';
import "./Table.css"
import moment from 'moment';
import Tippy from '@tippyjs/react';
import { BsFillTrashFill } from 'react-icons/bs';
import { FiEdit } from 'react-icons/fi';

function DataTable({ data, setCurrentActiveId, setActiveEditItem, setShowEditModal, setShowConfirmModal }: any) {
    const columns: any= [
        { 
          title: '#', 
          dataIndex: 'index', 
          key: 'index',
          render: (text: any, record: any, index: number) => index + 1,
        },
        {
          title: 'Name', 
          dataIndex: 'name', 
          key: 'name',
        },
        {
          title: 'Name French', 
          dataIndex: 'name_french', 
          key: 'name_french',
        },
        {
          title: 'Description', 
          dataIndex: 'description', 
          key: 'description',
        },
        {
          title: 'Description French', 
          dataIndex: 'description_french', 
          key: 'description_french',
        },
        
          {
            title: 'Price 1M',
            dataIndex: 'price_1m',
            key: 'price_1m',
            render: (price_1m: any) => (price_1m ? `${price_1m} CFA` : '---')
          },
          {
            title: 'Price 3M',
            dataIndex: 'price_3m',
            key: 'price_3m',
            render: (price_1m: any) => (price_1m ? `${price_1m} CFA` : '---')
          },
          {
            title: 'Price 6M',
            dataIndex: 'price_6m',
            key: 'price_6m',
            render: (price_1m: any) => (price_1m ? `${price_1m} CFA` : '---')
          },
          {
            title: 'Price 12M',
            dataIndex: 'price_12m',
            key: 'price_12m',
            render: (price_1m: any) => (price_1m ? `${price_1m} CFA` : '---')
          },
          {
            title: "Action",
            dataIndex: "action",
            key: "action",
            render: (text: any, record: any) => (
              <td className="flex-center">
                <div className="action">
                <Tippy content="Edit" animation="fade">
                    <a
                      className="see"
                      onClick={() => {
                        // Add your logic here when Activate button is clicked
                        // console.log('RECORD: ', record);
                        // alert('OK')
                        setActiveEditItem(record);
                        setShowEditModal(true);
                      }}
                    >
                    <FiEdit
                      style={{
                        color: "white",
                      }}
                       size={18} />
                    </a>
                  </Tippy>
        
                    <Tippy content="Delete" animation="fade">
                      <a
                        onClick={() => {
                          setCurrentActiveId(record.id);
                          setShowConfirmModal(true);
                        }}
                        className="delete"
                      >
                        <BsFillTrashFill size={18} />
                      </a>
                    </Tippy>
                </div>
                
              </td>
            ),
        
          },
      ];
  
      

    return (
        <Table
            columns={columns}
            // expandable={{ expandedRowRender, defaultExpandedRowKeys: ['0'] }}
            dataSource={data.map((item: any, index: any) => ({ ...item, index: index + 1 }))}
      />
    );
}

export default DataTable;